let navigateFn = null;

export const setNavigateFn = (fn) => {
  navigateFn = fn;
};

export const navigateTo = (path) => {
  if (navigateFn) {
    navigateFn(path);
  } else {
    window.location.href = path;
  }
};
